import type { FieldMeta } from 'vee-validate';
import type { CountryObject, PhoneObject } from 'vue-tel-input';
import type { FieldSizeType } from '../FormField';

export type FixedVueTelInputResponse = PhoneObject;

export const PhoneInputMode = {
  INTERNATIONAL: 'international',
  NATIONAL: 'national',
  AUTO: 'auto',
} as const;
export type PhoneInputModeType =
  (typeof PhoneInputMode)[keyof typeof PhoneInputMode];

export type PhoneInputProps = {
  id?: string;
  testId?: string;
  modelValue?: string;
  label?: string;
  helperText?: string;
  name: string;
  placeholder?: string;
  error?: string;
  warning?: string;
  disabled?: boolean;
  disabledReason?: string;
  autofocus?: boolean;
  required?: boolean;
  disableAutoFormat?: boolean;
  allowAnyCharacters?: boolean;
  loading?: boolean;
  meta?: FieldMeta<string>;
  optionalLabel?: boolean;
  defaultCountry?: string;
  inputType?: string;
  mode?: PhoneInputModeType;
  size?: FieldSizeType;
};

export type PhoneInputEmits = {
  'update:modelValue': [value: string];
  phoneDetails: [phoneObj: FixedVueTelInputResponse];
  validate: [phoneObj: FixedVueTelInputResponse];
  countryChanged: [countryObject: CountryObject];
  blur: [ev?: Event];
  focus: [ev?: Event];
  space: [ev?: Event];
  enter: [ev?: Event];
  open: [ev?: Event];
  close: [ev?: Event];
};
